<div
  tabindex="0"
  role="region"
  [attr.aria-label]="content?.title || content?.siteName || content?.url || ('translations.global.label.preview' | transloco)"
  [class.is_hidden]="!content?.html && !content?.title"
  class="external-preview__container
     external-preview__container-position-{{ content?.position || 'CENTER' }}"
  #htmlContent
>
  @if (content?.html && !embedsAllowed()) {
    <ptl-embed-consent-placeholder
      [url]="content?.url"
      [siteName]="content?.siteName"
      [compact]="folioAttachmentPreviewView"
    ></ptl-embed-consent-placeholder>
  }

  @if (!folioAttachmentPreviewView && content?.html) {
    <div class="external-preview-element__caption-box">
      <p
        role="button"
        tabindex="0"
        class="caption-text"
        [attr.aria-label]="'translations.global.ariaLabels.openUrl' | transloco: { url: content?.url }"
        (click)="openUrl()"
        (keydown.enter)="openUrl()"
      >
        {{ content?.url }}
      </p>
    </div>
  }

  @if (!content?.html && content?.title) {
    <a class="external-preview__card" [href]="content?.url" target="_blank" rel="noopener noreferrer">
      @if (content?.logoUrl || content?.thumbnailUrl) {
        <div class="external-preview__card-image">
          <img [src]="content?.logoUrl || content?.thumbnailUrl" [alt]="content?.title || content?.siteName || content?.url" />
        </div>
      }
      <div class="external-preview__card-content">
        <h4 class="external-preview__card-title">{{ content?.title }}</h4>
        @if (content?.description) {
          <p class="external-preview__card-description">{{ content?.description }}</p>
        }
        <span class="external-preview__card-link">{{ content?.siteName || content?.url }}</span>
      </div>
    </a>
  }
</div>
